module.exports = __webpack_public_path__ + "static/img/tca.9cf4c51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/tca.svg
// module id = qh5f
// module chunks = 0